import gql from 'graphql-tag'

export const REQUEST_FORGET_PASSWORD_USER = gql`
  mutation ($input: RequestForgetPasswordUserInput!) {
    requestForgetPasswordUser(input: $input) {
      errors
    }
  }
`

export default {
  REQUEST_FORGET_PASSWORD_USER
}
